export default class PresentListUserView {
    constructor(json) {
        this.from = json.from;
        this.until = json.until;
        this.user = json.user;
    }
}
